<template>
  <el-input v-bind="$attrs" v-on="$listeners" v-model="bankAccount" class="bank-account" />
</template>

<script>
export default {
  props: {
    value: {
      type: String
    }
  },

  inheritAttrs: false,

  data() {
    return {
      bankAccount: ""
    };
  },

  computed: {
    reallyBankAccount() {
      return this.getReallyBankAccount(this.bankAccount)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.bankAccount = newValue;
      }
    },

    bankAccount: {
      immediate: true,
      handler(newVal, oldVal) {
        const formatNum = this.getFormatBankAccount(newVal);

        this.$nextTick(_ => {
          this.$emit("input", formatNum);
          if (formatNum !== newVal) {
            this.changeAccountInputCursor(newVal, oldVal);
          }
        });
      }
    }
  },

  methods: {
    getFormatBankAccount(account) {
      return account.replace(/\D/g, "").replace(/....(?!$)/g, "$& ");
    },

    getReallyBankAccount(account) {
      return account.replace(/\s/g, "");
    },

    changeAccountInputCursor(newVal, oldVal) {
      const bankAccountDom = document.getElementsByClassName("bank-account")[0].firstElementChild;
      const currentCursorIndex = bankAccountDom.selectionStart;

      if (bankAccountDom.setSelectionRange) {
        setTimeout(_ => {
          this.setSelectionRange(newVal, oldVal, currentCursorIndex, bankAccountDom);
        }, 0);
      }
    },

    setSelectionRange(newVal, oldVal = "", currentCursorIndex, bankAccountDom) {
      if (newVal.length > oldVal.length) {
        const currentChars = newVal.charAt(currentCursorIndex - 1);
        const reg = /\D/;

        if (reg.test(currentChars)) {
          if (currentChars === " ") {
            return bankAccountDom.setSelectionRange(currentCursorIndex - 1, currentCursorIndex - 1);
          }
          const firstIllegalCharacterIndex = newVal.split("").findIndex(str => !(/[\d\s]/.test(str)));

          return bankAccountDom.setSelectionRange(firstIllegalCharacterIndex, firstIllegalCharacterIndex);
        }

        const startIndex = currentCursorIndex - 5 >= 0 ? currentCursorIndex - 5 : 0;
        const endIndex = currentCursorIndex;
        const splitStr = newVal.slice(startIndex, endIndex);

        if (splitStr.length === 5 && splitStr.indexOf(" ") == -1) {
          return bankAccountDom.setSelectionRange( currentCursorIndex + 1, currentCursorIndex + 1);
        }
      }
      return bankAccountDom.setSelectionRange(currentCursorIndex, currentCursorIndex);
    }
  }
};
</script>